import {userProfileManager} from '../../util/user-profile-manager';


export var OrderHistoryService = function($http, $q, accountConfigManager, searchParam) {
    var orderInfo = {};

    var countryCode = accountConfigManager.site['countryCode'];

    var jwt_token = userProfileManager.getJWT();

    var historyServiceEndPoint = '/shop-service/api/v2/order/list/{accountId}?beginDate='
        + searchParam + '&cntryCd=' + countryCode + '&eid=' + jwt_token;

    var accountId = userProfileManager.getUserProfileMasterInfo().accountId;

    var headerConfig = {
        headers: {
            'content-type': 'application/json',
            'showgloballoader': true,
            'client_id': accountConfigManager.system['mulesoft.client_id'],
            'client_secret': accountConfigManager.system['mulesoft.client_secret']
        }
    };

    orderInfo.getOrderHistoryForAccount = function() {
        var url = historyServiceEndPoint.replace('{accountId}', accountId);
        return $http.get(url, headerConfig);
    };

    return orderInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/order-history-service.js
// module id = 241
// module chunks = 0